import { Component, inject } from '@angular/core';
import { CheckoutExampleService } from '../../checkout-example.service';
import { ShopService } from '@app/services/shops/shop.service';

@Component({
  selector: 'order-summary-preview',
  templateUrl: './order-summary-preview.component.html',
  styleUrl: './order-summary-preview.component.scss',
  standalone: false,
})
export class OrderSummaryPreviewComponent {
  private checkoutExampleService = inject(CheckoutExampleService);
  readonly orderSubtotal = this.checkoutExampleService.orderSubtotal;
  readonly orderShipping = this.checkoutExampleService.orderShipping;
  readonly orderTotal = this.checkoutExampleService.orderTotal;

  currencySymbol = this.shopService.shopCurrencySymbol;
  constructor(private shopService: ShopService) {}
}
